const state = {
  publicPlans: [],
  adminPlans: [],
};

export default state;
